// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from '../NoDataCell';
import { formatMessage, formatOrdinalSuffix } from '@/utils/i18n/i18n';
import { RankingLimit, ESGColourDefinition } from '@/enums/Esg';
import ComparisonItem from '@/types/comparison-item';
import DisclaimerInfos from '@/types/disclaimer-infos';
import Locale from '@/types/locale';

type Props = {
  value?: number;
  className?: string;
  item?: ComparisonItem;
  disclaimer?: string;
  onClick?: () => void;
  id?: string;
  valueDisclaimer?: DisclaimerInfos;
  hasDisclaimer?: boolean;
  locale?: Locale;
};

const PercentileCell: React.FunctionComponent<Props> = ({ value, className, disclaimer, valueDisclaimer, item, onClick, id, hasDisclaimer, locale }: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  const roundedValue = +value.toFixed();

  const getColor = (value?: number) => {
    if (!value) return ESGColourDefinition.NA;
    if (value > RankingLimit.HIGH) return ESGColourDefinition.TEXT_ALIGNED;
    if (value >= RankingLimit.MODERATE) return ESGColourDefinition.TEXT_MODERATE;
    return ESGColourDefinition.TEXT_STRONGLY_MISALIGNED;
  };

  return (
    <div className={classNames(className, 'cell esg-rating-cell')} id={id ? `cell-${id}` : undefined} onClick={onClick} style={{ color: getColor(value) }}>
      <span className="markup-container">
        {roundedValue}
        {roundedValue ? formatOrdinalSuffix(roundedValue) : formatMessage('Common.OrdinalSuffix.Other')}
      </span>
    </div>
  );
};

export default PercentileCell;
